<template>
    <section class="section">
<!--        Loading bars-->
        <csv-parser ref="parser" :done.sync="doneChunking"></csv-parser>
<!--        <h1 v-if="doneChunking" class="title">{{csvFile.name}}</h1>-->
        <div class="columns">
<!--            Sidebar-->
            <div v-if="sidebarEnabled && doneChunking" class="column is-2-widescreen is-3-desktop is-4-tablet panel">
                <div class="panel">
                    <div class="panel-heading ">{{csvFile.name}}</div>
                    <div class="panel-tabs">
                        <a class="has-text-centered" :class="{ 'is-active': activeTab === 'Search' }" @click="activeTab = 'Search'">Search</a>
                        <a class="has-text-centered" :class="{ 'is-active': activeTab === 'Display Settings' }" @click="activeTab = 'Display Settings'">Display Settings</a>
                        <a class="has-text-centered" :class="{ 'is-active': activeTab === 'Export' }" @click="activeTab = 'Export'">Export</a>
                    </div>
                    <div v-if="activeTab === 'Search'">
                        <b-collapse :open="false" aria-controls="searchEverywhere">
                            <div slot="trigger" class="panel-block" role="button" aria-controls="searchEverywhere">
                                <span class="panel-icon">
                                  <i class="fas fa-search" aria-hidden="true"></i>
                                </span>
                                Search Everywhere
                            </div>
                            <div class="panel-block field has-addons">
                                <div class="control has-icons-left">
                                    <label>
                                        <input class="input is-small" type="text" placeholder="search" v-model="searchEverywhere">
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-search" aria-hidden="true"></i>
                                        </span>
                                    </label>
                                </div>
                                <div class="control" style="width: min-content;">
                                    <a class="button is-info is-small" @click="search">Search</a>
                                </div>
                            </div>
                        </b-collapse>
                        <b-collapse :open="false" aria-controls="search">
                            <div slot="trigger" class="panel-block" role="button" aria-controls="search">
                                <span class="panel-icon">
                                  <i class="fas fa-search" aria-hidden="true"></i>
                                </span>
                                Search By Field
                            </div>
                            <div class="panel-block is-block">
                                <b-field label="Field Name">
                                    <b-select v-model="filterField" placeholder="Select a field to search on">
                                        <option v-for="option in fields" :value="option.field" :key="option.field">{{ option.label }}</option>
                                    </b-select>
                                </b-field>
                                <b-field label="Value">
                                    <b-input v-model="filterValue" icon="search" iconPack="fas"></b-input>
                                </b-field>
                                <div class="field is-grouped is-grouped-multiline">
                                    <div class="control">
                                        <b-button class="is-info" @click="search">Search</b-button>
                                    </div>
                                    <div class="control is-expanded">
                                        <label class="select is-fullwidth">
                                            <select v-model="filterType" required>
                                                <option value="Partial">Partial Match</option>
                                                <option value="Exact">Exact Match</option>
                                                <option value=">">&gt;</option>
                                                <option value="<">&lt;</option>
                                                <option value=">=">&gt;=</option>
                                                <option value="<=">&lt;=</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                        <b-collapse :open="false" aria-controls="clear">
                            <div slot="trigger" class="panel-block" role="button" aria-controls="clear">
                                <span class="panel-icon">
                                    <i class="fas fa-search-minus">
                                    </i>
                                </span>
                                Clear All Searches
                            </div>
                            <div class="panel-block is-block has-text-centered">
                                <b-button @click="clearSearch">Clear</b-button>
                            </div>
                        </b-collapse>
                        <b-collapse :open="false" aria-controls="clear">
                            <div slot="trigger" class="panel-block" role="button" aria-controls="clear">
                                <span class="panel-icon">
                                    <i class="fas fa-scroll">
                                    </i>
                                </span>
                                Go to Page
                            </div>
                            <div class="panel-block">
                                <div class="field has-addons" style="max-width: 20ch; margin: auto;">
                                    <div class="control">
                                        <label>
                                            <input class="input" type="number" v-model="toPage">
                                        </label>
                                    </div>
                                    <div class="control" style="width: min-content;">
                                        <a class="button is-info" @click.prevent="goToPage">Go To Page</a>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                    <div v-if="activeTab === 'Display Settings'">
                        <div class="panel-block">
                            <div class="field is-horizontal is-block-mobile">
                                <div class="field-label is-normal">
                                    <label class="label" style="width: max-content">Rows per page</label>
                                </div>
                                <div class="field-body">
                                    <b-input type="number" max="100" min="1" v-model="rowsPerPage" style="max-width: 10ch;"></b-input>
                                </div>
                            </div>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="isSortable" type="is-info">Enable Sorting</b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="isStriped" type="is-info">Enable Striping</b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="isHoverable" type="is-info">Enable Row Highlighting</b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="gridEnabled" type="is-info">Enable Grid</b-switch>
                        </div>
                    </div>
                    <div v-if="activeTab === 'Export'">
                        <a class="panel-block" @click="downloadFile()">
                            <span class="panel-icon">
                              <i class="fas fa-file-export" aria-hidden="true"></i>
                            </span>
                            Export Entire Dataset
                        </a>
                        <a class="panel-block" @click="exportCurrentView()">
                            <span class="panel-icon">
                              <i class="fas fa-file-export" aria-hidden="true"></i>
                            </span>
                            Export Current Search Results
                        </a>
                    </div>
                </div>
            </div>
<!--            The actual Table-->
<!--            These CSS Positions (and height being set via JS) are hacks to allow scrolling to work inside of a flexbox-->
            <div class="column" style="position: relative;" :style="{height: 'calc(' +tableHeight + 'px + 2em'}">
                <div style="position: absolute; left:0; right:0;">
                <div v-if="scrollWidth" ref="scrollbar" style="overflow-x: scroll; width: 100%; height: 1em;" @scroll="scrollTable">
                    <div style="overflow-x: scroll; width: 100%;" :style="{width: scrollWidth + 'px'}"></div>
                </div>
                <b-table v-if="doneChunking" id="csvViewerTable" ref="table" :data="filteredData" :columns="fields"
                         :narrowed="!gridEnabled" :hoverable="isHoverable" :bordered="gridEnabled" :striped="isStriped"
                         :paginated="true" :per-page="rowsPerPage" :current-page.sync="currentPage"
                         :mobile-cards="false" icon-pack="fas"
                         :selected.sync="selectedRow"
                         @hook:mounted="setupScrolling" @hook:updated="setupScrolling"
                         style="box-sizing: border-box"
                >
                    <template slot="bottom-left">
                        <b-switch v-model="sidebarEnabled" type="is-info">Enable Sidebar</b-switch>
                    </template>
                </b-table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import BField from "buefy/src/components/field/Field";
    import BInput from "buefy/src/components/input/Input";
    import BSwitch from "buefy/src/components/switch/Switch";
    import BButton from "buefy/src/components/button/Button";
    import BTable from "buefy/src/components/table/Table";
    import BSelect from "buefy/src/components/select/Select";
    import BCollapse from "buefy/src/components/collapse/Collapse";
    import CsvParser from "../components/CsvParser";

    const Papa = require("papaparse");

    export default {
        name: "CsvViewer",
        components: {CsvParser, BCollapse, BSelect, BTable, BButton, BSwitch, BInput, BField},
        props: {
            fileId: {
                type: [String, Number],
                required: true,
            },
        },
        data: () => ({
            //Loading/done indicators
            'doneChunking': false,

            //Enable/disable toggles, and temp data for what the user selects
            'sidebarEnabled': true,
            'isSortable': true,
            'isStriped': false,
            'isHoverable': false,
            'gridEnabled': true,
            'rowsPerPage': 20,
            'activeTab': 'Search',
            'toPage': 1,
            'selectedRow': {},

            //Table Data
            'data': [],
            'fieldIds': [],
            'currentPage': 1,
            //Table size information
            'scrollWidth': 0,   //This also acts as a convenient way to check if the b-table is actually displaying data
            'tableHeight': 0, //The height of the table, used as part of CSS overflow hacks

            //These are set via the sidebar
            'filterField': null,
            'filterValue': '',
            'filterType': 'Partial',
            'searchEverywhere': '',
            //This is the data after search is performed
            //it's not a computed property, because it's asynchronously calculated only when 'search' is called
            'filteredData': [],
        }),
        computed: {
            fields: function () {
                let fields = [];
                this.fieldIds.forEach((element) => {
                    fields.push({
                        field: element,
                        label: element,
                        sortable: this.isSortable,
                    })
                });
                return fields;
            },
            //The wrapper object containing the table.  It is needed for scrolling reasons.
            tableWrapper: function () {
                return this.$refs.table.$el.getElementsByClassName('table-wrapper')[0];
            },
            csvFile: function () {
                return this.$store.getters['files/fileById'](this.fileId);
            }
        },
        watch: {
            currentPage(value) {
                this.toPage = value;
            },
        },
        async mounted() {
            //If the page is loaded directly, the list of all files needs to be populated
            if(!this.$store.state.files.files.length) {
                await this.$store.dispatch('files/getFiles');
            }
            try {
                [this.fieldIds, this.data] = await this.$refs.parser.loadCsv(this.csvFile.file);
                this.search();
            } catch (error) {
                console.log(error);
                alert('Unable to load Data');
                this.$router.back();
            }
        },
        methods: {
            //Hackily reach deep into the B-table's DOM and change things
            //NOTE:  This is being called every time the table updates, merely because that's the only way to make sure the scrollbar width is accurate.
            setupScrolling: function (event) {
                let table = this.tableWrapper.getElementsByTagName('table')[0];

                if(!this.scrollWidth) {
                    //Make the table itself scrollable
                    this.tableWrapper.style['overflow-x'] = 'scroll';
                    this.tableWrapper.addEventListener('scroll', this.scrollScrollbar);
                }
                this.scrollWidth = table.offsetWidth;

                //Go ahead and set the JS hack for table height too
                this.tableHeight = this.$refs.table.$el.offsetHeight;
            },
            //Scroll the table when the other scrollbar moves
            scrollTable: function (event) {
                this.tableWrapper.scroll(this.$refs.scrollbar.scrollLeft, 0);
            },
            //Move the other scrollbar when the table is scrolled
            scrollScrollbar: function (event) {
                this.$refs.scrollbar.scroll(this.tableWrapper.scrollLeft, 0);
            },
            goToPage() {
                this.currentPage = Number(this.toPage);
            },
            async search() {
                this.filteredData = await this.getSearchEverywhereData();
            },
            async getFilterFieldData() {
                return new Promise(async (resolve, reject)=> {
                    if (!this.filterField) {
                        resolve(this.data);
                        return;
                    }
                    resolve(this.data.filter(row => {
                        switch (this.filterType) {
                            case 'Exact':
                                return (String(row[this.filterField]) === String(this.filterValue));
                            case '>':
                                return (row[this.filterField] > this.filterValue);
                            case '<':
                                return (row[this.filterField] < this.filterValue);
                            case '>=':
                                return (row[this.filterField] >= this.filterValue);
                            case '<=':
                                return (row[this.filterField] <= this.filterValue);
                            default: //Also matches "Partial"
                                return (String(row[this.filterField]).toLowerCase().search(this.filterValue.toLowerCase()) >= 0);
                        }
                    }));
                });
            },
            //Relies on getFilterFieldData since that should be a much smaller data set to search through
            async getSearchEverywhereData() {
                return new Promise(async (resolve, reject)=> {
                    const searchData = await this.getFilterFieldData();
                    if(!this.searchEverywhere) {
                        resolve(searchData);
                        return;
                    }
                    resolve(searchData.filter(row => {
                        for (let value of Object.values(row)) {
                            if (String(value).toLowerCase().search(this.searchEverywhere.toLowerCase()) >= 0) {
                                return true;
                            }
                        }
                        return false;
                    }));
                });
            },
            clearSearch: function () {
                //Go ahead and clear the current selected row as well
                this.selectedRow = {};
                this.filterField = null;
                this.filterValue = '';
                this.searchEverywhere = '';
                this.search();
            },
            downloadFile: function () {
                this.$gtag.event('download', {event_category: 'File', event_label: this.csvFile.name});
                window.open(this.csvFile.file);
            },
            exportCurrentView: function () {
                this.$gtag.event('download-view', {event_category: 'File', event_label: this.csvFile.name});
                let csv = Papa.unparse(this.filteredData, {
                    columns: this.fieldIds,
                });
                let file = new File([csv], 'Exported Report.csv', {type: "text/csv;charset=utf-8"});
                window.open(window.URL.createObjectURL(file));
            }
        },
    }
</script>

<style scoped>

</style>